import { render, staticRenderFns } from "./TemplateItemManager.vue?vue&type=template&id=ea96c2e2&scoped=true"
import script from "./TemplateItemManager.vue?vue&type=script&lang=js"
export * from "./TemplateItemManager.vue?vue&type=script&lang=js"
import style0 from "./TemplateItemManager.vue?vue&type=style&index=0&id=ea96c2e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea96c2e2",
  null
  
)

export default component.exports